import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import router from "./router";
import auth from './auth'
import axios from 'axios'

Vue.config.productionTip = false;

Vue.use(VueRouter);

// Adding token to each axios request
axios.interceptors.request.use(async function(config) {
  try {
    let token = await auth.getAcessToken();
    config.headers['X-Authorization'] = `Bearer ${token}`;
    return config;
  }
  catch (err) {
    console.log("Intereptor request error: ", info)
    return Promise.reject(err)
  }
});

// Checking for user auth before each request. Challenging if not.
router.beforeEach((to, from, next) => {
  auth.getSessionState().then(isSessionActive => {
    if (isSessionActive)
      next();
  });
});


axios.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {

    if (error.response.status === 401) {
      try {
        const originalRequest = error.config
        // token expired
        let user = await auth.manager.signinSilent();
        originalRequest.headers['X-Authorization'] = user.access_token;
        return axios(originalRequest)
      }
      catch (error) {
        auth.signOut();
        console.log("Interceptor response error:", error);
        return Promise.reject(error);
      }
    }
    console.log(error);
    return Promise.reject(error);
  });

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
